module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/Strawberry_symbol@2x.png?0.0.53";